module.exports = __webpack_public_path__ + "img/compromiso_msh.026aff85.jpg";